import isArray from 'onyx-common/isArray'

const castToArray = testArr => {
  return isArray(testArr) ? testArr : [testArr]
}

export default castToArray
